/*
 * Created by jmeo at 2021-05-11
 * FileName: Input.tsx
 */

import React, {PropsWithChildren, useState} from "react";


export type InputPropsType = {
    defaultValue?: string | number;
    value?: string | number;
    type?: 'text' | 'number' | 'password';
    placeholder?: string;
    onChange?: (e: any) => void;
    onBlur?: (e: any) => void;
    onClick?: () => void;
    maxLength?: number;
    minLength?: number;
    min?: number;
    max?: number;
    disabled?: boolean;
}

export type ActionInputPropsType = InputPropsType & {
    clear?: boolean
}

export type PropsType = {
    unit?: string
} & InputPropsType


export const Input: React.FC<InputPropsType> = (props: InputPropsType) => {
    const type = props.type || 'text'
    const maxLength = props.maxLength
    // 当type为number时，maxlength 参数无效因此需要手动进行处理
    let value = props.value || props.value === 0 ? String(props.value) : ""
    if (typeof maxLength === "number" && maxLength > 0 && value.length > maxLength) {
        value = value.substring(0, maxLength)
        // 为避免在state render 渲染时造成dom操作异常
        setTimeout(() => {
            props.onChange && props.onChange(Number(value))
        }, 0)
    }
    return (
        <input
            maxLength={props.maxLength}
            minLength={props.minLength}
            defaultValue={props.defaultValue}
            value={value}
            readOnly={props.disabled}
            type={type}
            onBlur={(e) => props.onBlur && props.onBlur(e)}
            onChange={(e) => {
                const val = e.target.value
                if (type === 'number') {
                    if ((props.max || props.max === 0) && props.max < Number(val)) {
                        props.onChange && props.onChange(props.max)
                    } else if ((props.min || props.min === 0) && props.min > Number(val)) {
                        props.onChange && props.onChange(props.min)
                    } else {
                        props.onChange && props.onChange(val)
                    }
                } else {
                    props.onChange && props.onChange(val)
                }
            }}
            placeholder={props.placeholder}/>
    )
}


export const ActionInput: React.FC<ActionInputPropsType> = (props: PropsWithChildren<ActionInputPropsType>) => {
    const {clear, type} = props
    const [showPassword, setShowPassword] = useState(false)
    return (
        <div>
            <Input {...props} type={showPassword && type === 'password' ? 'text' : type}/>
            {
                // show/hide password
                type === 'password' && (
                    <i className={showPassword ? 'icon-hide-pwd' : 'icon-show-pwd'}
                       onClick={() => {
                           setShowPassword(!showPassword)
                       }}/>
                )
            }
            {
                // clear btn
                type !== 'password' && clear && (
                    <i className="icon-clear" onClick={() => {
                        props.onChange && props.onChange(undefined)
                    }}/>
                )
            }

        </div>
    )
}


export default function (props: PropsType) {
    const {unit} = props 
    return <div className="cfInput" onClick={() => props.onClick && props.onClick()}>
        <Input {...props}/>
        {
            unit && <div>{unit}</div>
        }
    </div>
}


type RadioPropsType = {
    label?: string,
    checked?: boolean,
    onClick?: (e: any) => void,
    style?: any,
    className?: any
}

export const Radio = (props: RadioPropsType) => {
    const {label, checked, onClick, style, className} = props
    const _className = ['cfInputRadio']
    checked && _className.push('checked')
    return <span onClick={(e) => onClick && onClick(e)} className={className} style={style}>
        <i className={_className.join(' ')}/> {label}</span>
}

type CheckBoxPropsType = RadioPropsType

export const Checkbox = (props: CheckBoxPropsType) => {
    const {label, checked, onClick, style, className} = props
    const _className = ['cfInputCheckbox']
    checked && _className.push('checked')
    if (label) {
        return <span onClick={(e) => onClick && onClick(e)} className={className} style={style}>
            <i className={_className.join(' ')}/>{label}</span>
    } else {
        return <i className={_className.join(' ')} style={style} onClick={e => onClick && onClick(e)}/>
    }
}
